'use client'

/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable react/no-danger */
import React, { useState, useEffect } from 'react'
import Image from 'next/image'
import { useUserData } from '@utils/userUserData'
import { isLoggedInUtil } from '@utils/utils'
import { VEHICLE_DATA } from '@components/MainWidget/ChallanWidgetLanding/constants'
import { healthWidgetIconConfig } from '@components/Product/ProductWidget/subComponents/ProductHealthInfoCard/healthWidgetConfig'
import { getCtaWidgetPurpleLayout, getpurpleRootContainerLayout } from '@configs/productWidget.config'
import { getClassNames, getDynamicHeadingTag } from '@helpers/productWidgetHelper'
import { CHALLAN_WIDGET_LANDING } from '@components/Product/ProductWidget/constants'
import { ProductWidgetHeaderProps, HeroImageProps } from './productInterfaces'
import styles from '../productWidget.module.scss'

const HeroImage: React.FC<HeroImageProps> = ({ imageUrl, width, height, alt, className }) => (
  <Image src={imageUrl} alt={alt} width={width} height={height} className={className} priority />
)

const HealthWidgetIcon: React.FC<{ position: 'left' | 'right' }> = ({ position }) => {
  const config = healthWidgetIconConfig[position]

  return (
    <div className={styles[config.className]}>
      <Image
        src={`https://acko-seo-prod.ackoassets.com/_next_static/images/${config.imagePath}`}
        alt={`product Health widget ${position} plus icon`}
        width={config.width}
        height={config.height}
        priority
      />
    </div>
  )
}

const renderHeading = (props: ProductWidgetHeaderProps) => {
  const { isSeoCarWidget, isHealthWidgetPurpleLayout, content, THEME_CONFIG } = props

  const isChallanLandingWidget = content?.widget === CHALLAN_WIDGET_LANDING

  const headingTag = getDynamicHeadingTag(content?.widget, isSeoCarWidget, isHealthWidgetPurpleLayout)

  const headingContainerClassNames = getClassNames([styles.newLayoutHeading], {
    [styles.boldHeading]: getCtaWidgetPurpleLayout[content?.widget],
    [styles.boldHeadingPurpleBg]: isChallanLandingWidget,
  })

  const newHeadingContainerClassNames = getClassNames([styles.newLayoutHeading], {
    [styles.boldHeadingMweb]: getpurpleRootContainerLayout[content?.widget],
    [styles.boldHeadingPurpleBg]: isChallanLandingWidget,
  })

  const classNames = isSeoCarWidget
    ? `${newHeadingContainerClassNames} ${THEME_CONFIG[content?.theme || '']}`
    : isHealthWidgetPurpleLayout
      ? styles.healthWidgetMainHeading
      : `${headingContainerClassNames} ${THEME_CONFIG[content?.theme || '']}`

  return React.createElement(headingTag, { className: classNames }, content?.productWidgetMainHeading)
}

const renderSubHeading = (props: ProductWidgetHeaderProps) => {
  const { isSeoCarWidget, isHealthWidgetPurpleLayout, content, THEME_CONFIG } = props

  const subHeadingContainerClassNames = getClassNames([styles.subHeading], {
    [styles.lighterSubHeading]: getCtaWidgetPurpleLayout[content?.widget],
  })

  if (isSeoCarWidget) {
    return (
      <div
        className={styles.subHeadingWithLineBreak}
        dangerouslySetInnerHTML={{ __html: content?.ProductWidgetSubHeading || '' }}
      />
    )
  }

  if (isHealthWidgetPurpleLayout) {
    return <p className={styles.healthWidgetMainSubHeading}>{content?.ProductWidgetSubHeading}</p>
  }

  return (
    <p className={`${subHeadingContainerClassNames} ${THEME_CONFIG[content?.theme || '']}`}>
      {content?.ProductWidgetSubHeading}
    </p>
  )
}

// Main Function
const ProductWidgetHeader: React.FC<ProductWidgetHeaderProps> = props => {
  const { content, isSeoCarWidget, isHealthWidgetPurpleLayout = false, reqCookie } = props

  const [showWelcomeText, setShowWelcomeText] = useState<string>('')
  const isLoggedIn: boolean = isLoggedInUtil(reqCookie)
  const userData = useUserData(isLoggedIn)
  const mobileImageUrl = content?.productWidgetHeroImageMobile?.data?.attributes?.url
  const desktopImageUrl = content?.productWidgetHeroImageDesktop?.data?.attributes?.url

  useEffect(() => {
    const storedData = localStorage.getItem(VEHICLE_DATA)
    if (storedData) {
      setShowWelcomeText(userData?.name ? `Welcome ${userData.name}` : 'Welcome back!')
    }
  }, [])

  return (
    <>
      {/* Non-SEO Car Widget Mobile Hero Image */}
      {!isSeoCarWidget && mobileImageUrl && (
        <HeroImage
          imageUrl={mobileImageUrl}
          width={190}
          height={190}
          alt="product widget Hero image mobile"
          className={styles.semHeroImageMweb}
        />
      )}

      {/* Health Widget Desktop Hero Image */}
      {isHealthWidgetPurpleLayout && desktopImageUrl && (
        <HeroImage
          imageUrl={desktopImageUrl}
          width={292}
          height={248}
          alt="product widget Hero image desktop"
          className={styles.semHeroImageWeb}
        />
      )}

      {/* Health Widget Icons */}
      {isHealthWidgetPurpleLayout && (
        <>
          <HealthWidgetIcon position="left" />
          <HealthWidgetIcon position="right" />
        </>
      )}
      {showWelcomeText && <p className={styles.welcomeBackHeader}>{showWelcomeText}</p>}
      {renderHeading(props)}
      {renderSubHeading(props)}
    </>
  )
}

export default ProductWidgetHeader
